import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { DetailsItemPlaceholderComponent } from '@shared/components';

@Component({
  selector: 'app-details-page-content-placeholder',
  templateUrl: './details-page-content-placeholder.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DetailsItemPlaceholderComponent],
})
export class DetailsPageContentPlaceholderComponent {
  @Input() singleColumn = false;
}
